import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { StudentInternshipModel } from "./student-internship-data.model";

export class StudentInternshipGridPostParams extends GridPostParams {
    tabNumber : number = 1
}

export class StudentInternshipGridModel extends StudentInternshipModel { }

export class StudentInternshipListingModel extends GridModel<StudentInternshipGridModel> {
}
